import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
`;
export const Hint = styled.p`
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;
